import React, {useEffect, useState} from 'react'
import {getAllCustomer} from "../../../services/serviceCustomer";
import OfferCreate from "./OfferCreate";
import {OfferContextProvider} from "../../../context/OfferContext";


const OfferCreateContainer = () => {
    const [customers, setCustomers] = useState()

    useEffect(() => {
        getAllCustomer()
            .then(({data}) => setCustomers(data))
    }, [])

    return (
        <React.Fragment>
            <OfferContextProvider>
                <OfferCreate customerList={customers}/>
            </OfferContextProvider>
        </React.Fragment>
    )
}
export default OfferCreateContainer